module.exports = __webpack_public_path__ + "static/media/background-checkout.b1a937c0.svg";